import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Filter from "../filter/filter";
import CarRental from "../carRentalContent/carRentalStatus";
import SortByHeader from "./sortByHeader";
import FooterContent from "../footercontent/footerContent";

const carbookingContent = () => {
  return (
    <section className="car-booking-content">
      <div className="content-wrap">
        <Container>
          <Row>
            <Col lg={3}>
              <div className="filter-wrap">
                <div className="title">Filter By</div>
               
                  <Filter />
               
              </div>
            </Col>

            <Col lg={9}>

            <Row>
              <Col>
              <SortByHeader />
              </Col>
            </Row>

            <Row>
              <Col>
                <CarRental />
              </Col>
            </Row>

            <Row>
              <Col>
                <FooterContent />
              </Col>
            </Row>
              
            </Col>
          </Row>
         
        </Container>
      </div>
    </section>
  );
};

export default carbookingContent;
